import React, { useState, useEffect, useCallback } from "react";
import { MdShoppingCart } from "react-icons/md";
import { BiChevronDown } from "react-icons/bi";
import message from "../../utils/message";
import GET from "../../utils/GET";
import useTrack, { eventTypes } from "../../hooks/useTrack";
import { CROSS_SELL_BANNER_IMAGE, CROSS_SELL_LOGO_IMAGE } from "../../conf";

import "./banner.css";

const orderCost = GET("cost");

const platformSelfPreview = (GET("selfPreview") && GET("platform")) || false;
const Banner = React.memo(({ name, details, minimizePPE = false }) => {
	let { logo_url, banner_url } = details;
	const [fired, setFired] = useState(false);
	const track = useTrack();

	const handleMinimize = useCallback(() => {
		message("MINIMIZE");
		message("MINIMIZE_MODAL");
		if (!fired) {
			track(eventTypes.SHOW_ORDER_CLICK);

			setFired(true);
		}
	}, [fired, track]);

	useEffect(() => {
		if (!minimizePPE) {
			return;
		}
		return handleMinimize();
	}, [minimizePPE, handleMinimize]);

	return (
		<>
			<section
				className="banner banner-primary"
				style={{
					backgroundImage: `url(${
						platformSelfPreview
							? CROSS_SELL_BANNER_IMAGE
							: banner_url
					})`,
				}}
			>
				<img
					src={platformSelfPreview ? CROSS_SELL_LOGO_IMAGE : logo_url}
					alt="brand-logo"
					className="banner-brand-logo banner-brand-logo-primary"
				/>
			</section>
			<section className="banner banner-secondary">
				<div className="banner-brand-detail-container">
					<div className="banner-brand-name">{name}</div>
				</div>
			</section>
			<section className="banner banner-order-details">
				<div
					className="banner-order-details-btn"
					onClick={handleMinimize}
				>
					<MdShoppingCart />
					<span>Show Order Details</span>
					<BiChevronDown />
				</div>
				<div className="banner-order-details-price">
					{orderCost ? orderCost : ""}
				</div>
			</section>
		</>
	);
});

export default Banner;
